import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './App.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar, utils  } from "react-modern-calendar-datepicker";
import { addDays, delegacionesPorModulo, diasPorServicio, DNIestaRegistrado, horasPorDia, serviciosPorDelegacion, todosModulos } from './APIfuncs/APIgetters';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { style } from '@mui/system';
import { useEffect } from 'react';
import { IconButton, TextField } from '@mui/material';
import * as Yup from "yup";
import CampoDeTexto from './Utilidades/CampoDeTexto';
import { useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { CreateSharp } from '@mui/icons-material';
import { insertarTurno } from './APIfuncs/APIposters';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import NuevoTurno from "./components/NuevoTurno"
import SearchIcon from '@mui/icons-material/Search';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function Test() {

  const [formEnviado, setFormEnviado] = useState(false);
  const [traminteEnviado, setTraminteEnviado] = useState(false);
  const [ubicacionEnviada, setUbicacionEnviada] = useState(false);
  const [tipoTraminteEnviado, setTipoTraminteEnviado] = useState(false);
  const [fechaEnviada, setFechaEnviada] = useState(false);
  const [datosPersonalesEnviados, setDatosPersonalesEnviados] = useState(false);
  const [mostrarHoras, setMostrarHoras] = useState(false);
  
  const [nombreModulo, setNombreModulo] = useState("");
  const [nombreDelegacion, setNombreDelegacion] = useState("");
  const [nombreServicio, setNombreServicio] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();

  const [hayParametroModulo, setHayParametroModulo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [necesitoLupita, setNecesitoLupita] = useState(true);

  const [nuevoTurnoInfo, setNuevoTurnoInfo] = useState(null);
  

  
  const theme = createTheme({
    palette: {
      primary: {
        light: '#757ce8',
        main: '#3f50b5',
        dark: '#002884',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ab3897',
        main: '#97077D',
        dark: '#690457',
        contrastText: '#fff',
      },
      desmarcado: {
        light: '#e6e6e6',
        main: '#e0e0e0',
        dark: '#9c9c9c',
        contrastText: '#97077D',
      },
    },
  });
  
  const textoPreguntas = { width: '100%', flexShrink: 0, fontFamily: "Brandon", fontWeight: 1000, fontSize: "20px", textAlign: "left" };
  const iconosPreguntas = {"minWidth": "10px", "width": "15px", "height": "30px", "borderRadius": "20px", "marginRight": "5px"};
  const respuestaElegida = {color: 'text.secondary', textAlign: "left", marginLeft: "40px"}

  const [datos, setDatos] = useState({
    idDelegacion: 0,
    idServicio: 0,
    idModulo: 0,
    dia: "",
    diaCompleto: "",
    hora: "",
    tipoDNIUser: "dni",
    dniUser: 0,
    emailUser: "",
    nombreUser: "",
    apellidoUser: "",
    telUser: "",
    direccionUser: "",
    localidadUser: "vicente lopez"
});

  const [modulos, setModulos] = useState(null);
  const [delegaciones, setDelegaciones] = useState();
  const [servicios, setServicios] = useState();
  const [opcionesServicios, setOpcionesServicios] = useState([]);
  const [horas, setHoras] = useState("");
  const [necesitaCheckDNI, setNecesitaCheckDNI] = useState(false);
  const [esDNIValido, setEsDNIValido] = useState(false);
  const [hayError, setHayError] = useState(false);
  const [mostrarNoHayHoras, setMostrarNoHayHoras] = useState(false);
  const idModuloDeportes = 73;

  const [selectedOptions, setSelectedOptions] = useState([]);

  const cargarOpcionesServicio = (servicio) => {
    opcionesServicios.push({value: servicio, label: servicio.nombre})
  }

    const myCustomLocale = {
      // months list by order
      months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
      ],
    
      // week days by order
      weekDays: [
        {
          name: 'Domingo', // used for accessibility 
          short: 'D', // displayed at the top of days' rows
          isWeekend: true, // is it a formal weekend or not?
        },
        {
          name: 'Lunes',
          short: 'L',
        },
        {
          name: 'Martes',
          short: 'M',
        },
        {
          name: 'Miércoles',
          short: 'X',
        },
        {
          name: 'Jueves',
          short: 'J',
        },
        {
          name: 'Viernes',
          short: 'V',
        },
        {
          name: 'Sábado',
          short: 'S',
          isWeekend: true,
        },
      ],
    
      // just play around with this number between 0 and 6
      weekStartingIndex: 0,
    
      // return a { year: number, month: number, day: number } object
      getToday(gregorainTodayObject) {
        return gregorainTodayObject;
      },
    
      // return a native JavaScript date here
      toNativeDate(date) {
        return new Date(date.year, date.month - 1, date.day);
      },
    
      // return a number for date's month length
      getMonthLength(date) {
        return new Date(date.year, date.month, 0).getDate();
      },
    
      // return a transformed digit to your locale
      transformDigit(digit) {
        return digit;
      },
    
      // texts in the date picker
      nextMonth: 'Next Month',
      previousMonth: 'Previous Month',
      openMonthSelector: 'Open Month Selector',
      openYearSelector: 'Open Year Selector',
      closeMonthSelector: 'Close Month Selector',
      closeYearSelector: 'Close Year Selector',
      defaultPlaceholder: 'Select...',
    
      // for input range value
      from: 'from',
      to: 'to',
    
    
      // used for input value when multi dates are selected
      digitSeparator: ',',
    
      // if your provide -2 for example, year will be 2 digited
      yearLetterSkip: 0,
    
      // is your language rtl or ltr?
      isRtl: false,
    }
    
    
    const defaultDay = utils().getToday();
    const [selectedDay, setSelectedDay] = useState(defaultDay);
    const [disabledDays, setDisabledDays] = useState([{}]);
    let diasDisponibles= [];
    let disabledDaysAux = addDays(defaultDay);

    const eliminarDia = (dia) => {
      let indexAux = disabledDaysAux.findIndex(element => (element.day == dia.day && element.month == dia.month && element.month == dia.month));
      if (indexAux > -1) disabledDaysAux.splice(indexAux, 1);
    }

    const habilitarDias = () => {
      diasDisponibles.map(dia => eliminarDia(dia));
    }

    const fechaADia = (fecha) => {

      let mesAux = fecha.month;
      let diasAux = fecha.day;

      if (fecha.month < 10) {
        mesAux = "0"+fecha.month;
      }
      if (fecha.day < 10) {
        diasAux = "0"+fecha.day;
      }
      
      const weekDays = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      let diaAux = new Date(fecha.year + "-"+ mesAux + "-" + diasAux + "T00:00:00");
      
      return (weekDays[diaAux.getDay()]);
    }

    const noHayHoras = (horas) => {
      if (horas.status == "error") {
        setMostrarNoHayHoras(true);
        return;
      }
      else if ((horas.filter(horas => horas.cupo > 0)).length < 1) {
        setMostrarNoHayHoras(true);
        return;
      }
      setMostrarNoHayHoras(false);
    }

    const [aviso, setAviso] = useState("");
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleDisabledSelect = () => {
      setAviso(
        <div>
          <p>
            El día que intento seleccionar no tiene cupos disponibles. <br/><br/>
            Por favor, seleccione otro.
          </p>
        </div>
      )
      handleOpen()
    }

    const desaparecerLupa = () =>{
      setNecesitoLupita(false);
    }

    const aparecerLupa = () =>{
      setNecesitoLupita(true);
    }

    const recibirModuloParam = async () => {
      const idIngresada = searchParams.get("modulo");
      let agria = await delegacionesPorModulo(setDelegaciones, idIngresada, setLoading);
      if (!agria.status) {
        setDatos({...datos, idModulo: idIngresada});   
        setTraminteEnviado(true);
        setHayParametroModulo(true);
        if(idIngresada == idModuloDeportes) setNecesitaCheckDNI(true);
      }
      else if (delegaciones) {
        setDelegaciones();
      }
    }
  
    useEffect(() => {
      todosModulos(setModulos, setLoading);
      recibirModuloParam();
    },[])

    const VALORES_INICIALES = {
      dni: "",
      nombre: "",
      apellido: "",
      domicilio: "",
      correo: "",
      celular: "",
    }
      
    const FORM_VALIDATION = Yup.object().shape({
      nombre: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido')
          .required("Ingrese un nombre"),
      apellido: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido')
          .required("Ingrese un apellido"),
      domicilio: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ0-9_.-.\s]*$/ , 'Ingrese un domicilio válido')
          .required("Ingrese un domicilio"),
      correo: Yup.string()
          .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ , 'Ingrese un Email válido')
          .required("Ingrese un correo"),
      celular: Yup.string()
          .matches(/^[\[0-9\]*]{1,40}$/ , 'Ingrese un celular válido (sin "+" ni "-")')
          .required("Ingrese un celular"),
    });

    const FORM_VALIDATION_DNI = Yup.object().shape({
      dni: Yup.number()
          .typeError("Ingrese un DNI válido (sin espacios ni '.')")
          .required("Ingrese un DNI"),
      nombre: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido')
          .required("Ingrese un nombre"),
      apellido: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido')
          .required("Ingrese un apellido"),
      domicilio: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ0-9_.-.\s]*$/ , 'Ingrese un domicilio válido')
          .required("Ingrese un domicilio"),
      correo: Yup.string()
          .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ , 'Ingrese un Email válido')
          .required("Ingrese un correo"),
      celular: Yup.string()
          .matches(/^[\[0-9\]*]{1,40}$/ , 'Ingrese un celular válido (sin "+" ni "-")')
          .required("Ingrese un celular"),
    });

    const elegirEsquemaVal = () => {
      if (necesitaCheckDNI) {
        return FORM_VALIDATION;
      }
      return FORM_VALIDATION_DNI;
    }

  return (
    
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{"textAlign": "center", "color": "#97077D", "fontWeight": "bold"}} >{"Importante:"}</DialogTitle>
        <DialogContent sx={{px: "40px"}}>
          <DialogContentText id="alert-dialog-slide-description">
            {aviso}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!formEnviado && <Button onClick={handleClose}>Entendido</Button>}
          {(formEnviado || hayError) && <Button href='/nuevaturnera'>Entendido</Button>}
        </DialogActions>
      </Dialog>

      <Dialog
        open={loading}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent sx={{px: "20px"}}>
          <DialogContentText id="alert-dialog-slide-description" style={{display:"flex", alignItems: "center"}}>
            <CircularProgress style={{"marginRight": "40px"}} color='secondary'/> Cargando... 
          </DialogContentText>
        </DialogContent>
      </Dialog>
      

      <div style={{'display':` ${formEnviado ? 'none' : ''}`}}>
      {!hayParametroModulo && <Accordion style={{"margin": "0px"}} expanded={!traminteEnviado}>
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          style={{ pointerEvents: 'none'}}
          >
          <div>
            <Typography sx={textoPreguntas} >
            {traminteEnviado ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >1</Button>}
              ¿De que área desea obtener un turno?
            </Typography>
            {traminteEnviado && <Typography sx={respuestaElegida}>
              {nombreModulo}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0px'}}>
            <Formik
            initialValues={{
            tramite: "",
            }}

            validate={(valores) =>{
            let errores = {};
            if (!valores.tramite) {
                errores.tramite = "Seleccione una opción.";
            }
            return errores;
            }}

            onSubmit={async(valores) =>{
                setDatos({...datos, idModulo: valores.tramite});   
                await delegacionesPorModulo(setDelegaciones, valores.tramite, setLoading);
                setTraminteEnviado(true);
            }}>

            {( { errors,} ) => (
              <Form className='formulario'>
                {modulos && <div name="tramite">
                    {modulos.map(tramite => 
                    
                        <label className='opciones'>
                             <Field key={tramite.idModulo} type="radio" name="tramite" value={tramite.idModulo} onClick={() => {setNombreModulo(tramite.nombreModulo); if(tramite.idModulo == idModuloDeportes) setNecesitaCheckDNI(true); else setNecesitaCheckDNI(false);}} /> {tramite.nombreModulo} 
                        </label>
                    
                    )}
                    <ErrorMessage name="tramite" component={() => (<div className='error'>{errors.tramite}</div>)} />
                </div>}
                <div className='buttonContainer'>
                  <Button type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>}

      {necesitaCheckDNI && <Accordion style={{"margin": "0px"}} expanded={traminteEnviado && !esDNIValido} >
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <div>
            <Typography sx={textoPreguntas} >
            <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button>
              DNI
            </Typography>
            {esDNIValido && <Typography sx={respuestaElegida}>
              {datos.dniUser}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{dni: ""}}
            validationSchema={Yup.object().shape({
              dni: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')")
                  .required("Ingrese un DNI")})}
            
            onSubmit={async(valores) =>{

              const checkAux = await DNIestaRegistrado(valores.dni, setLoading);

              if (checkAux.registered) {
                setEsDNIValido(true);
                setDatos({...datos, dniUser: valores.dni});
              }
              else{
                setAviso(
                  <div>
                    <p> El DNI ingresado no es válido. </p>
                  </div>
                )
                handleOpen()
              }
            }}>
            {( { errors, }) => (
                <Form className='formulario'>
                  <div>
                      <CampoDeTexto 
                      type="number" 
                      id="dni" 
                      name='dni'
                      label="DNI"
                      />
                  </div>
                  <div className='buttonContainer'>
                  {!hayParametroModulo && <button type='button' className='formulario-atrasButton' onClick={() => {setTraminteEnviado(false);}}>Atras</button>}
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
                
        </AccordionDetails>
      </Accordion>}

      <Accordion style={{"margin": "0px"}} expanded={traminteEnviado && !ubicacionEnviada && ((necesitaCheckDNI && esDNIValido) || !necesitaCheckDNI)}>
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <div>
            <Typography sx={textoPreguntas} >
              {ubicacionEnviada ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroModulo? 1 : 2}</Button>}
              ¿Dónde realizará el trámite?
            </Typography>
            {ubicacionEnviada && <Typography sx={respuestaElegida}>
              {nombreDelegacion}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{
              ubicacion: "",
              }}

            validate={(valores) =>{
            let errores = {};

            if (!valores.ubicacion) {
                errores.ubicacion = "Seleccione una opción.";
            }

            return errores;
            }}

            onSubmit={async(valores) =>{
                setDatos({...datos, idDelegacion: valores.ubicacion});
                setUbicacionEnviada(true);
                let a = await serviciosPorDelegacion(setServicios, valores.ubicacion, setLoading);
                a.filter(serv => serv.activo == "1").map(tipoTramite => cargarOpcionesServicio(tipoTramite))
            }}>

            {( { errors, values}) => (
              <Form className='formulario'>
                     {traminteEnviado && !delegaciones.status && 
                    <div>
                        {delegaciones.filter(delegacion => delegacion.activo === "1").map(ubicacion => 
                        <>
                            <label className='opciones'>
                                <Field key={ubicacion.idDelegacion} 
                                type="radio" 
                                name="ubicacion" 
                                value={ubicacion.idDelegacion} 
                                onClick={() =>{
                                  setNombreDelegacion(ubicacion.nombreDelegacion);
                                  setAviso(<div dangerouslySetInnerHTML={{ __html: ubicacion.descripcionDelegacion }} />);
                                  if(ubicacion.descripcionDelegacion) handleOpen();
                                  }} /> {ubicacion.nombreDelegacion}
                            </label>
                        </>
                        )}
                    <ErrorMessage name="ubicacion" component={() => (<div className='error'>{errors.ubicacion}</div>)} />
                    </div>}
                    {traminteEnviado && delegaciones.status &&
                      <div>
                        <p>No hay dependencias cargadas.</p>
                      </div>
                    }
                <div className='buttonContainer'>
                  {!hayParametroModulo && <button type='button' className='formulario-atrasButton' onClick={() => {setTraminteEnviado(false); setDelegaciones(null); values.ubicacion=null; setEsDNIValido(false);}}>Atras</button>}
                  <Button disabled={loading} type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{"margin": "0px"}} expanded={ubicacionEnviada && !tipoTraminteEnviado} >
        <AccordionSummary
          style={{ pointerEvents: 'none', padd: "0.75% 0% 0.75%" }}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <div>
            
            <Typography sx={textoPreguntas}>
              {tipoTraminteEnviado ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroModulo? 2 : 3}</Button>}
              
              Seleccione tipo de trámite
            </Typography>
            {tipoTraminteEnviado && <Typography sx={respuestaElegida}>
              {nombreServicio}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{
            tipoTramite: "",
            }}
            
            validate={(valores) =>{
            let errores = {};

            if (!selectedOptions.idServicio) {
                errores.tipoTramite = "Seleccione una opción.";
            }

            return errores;
            }}

            onSubmit={async(valores) =>{
              diasDisponibles = await diasPorServicio(selectedOptions.idServicio, defaultDay.month, defaultDay.year, setLoading);
              if (diasDisponibles !== "error") {
                  setDatos({...datos, idServicio: selectedOptions.idServicio});
                  setTipoTraminteEnviado(true);
                  habilitarDias();
                  await setDisabledDays(disabledDaysAux);
                }
                else{
                  setAviso(
                    <div>
                      <p>
                      El trámite seleccionado no tiene planes de horarios disponibles.
                      </p>
                    </div>
                  );
                  handleOpen();
                }
            }}>

            {( { errors, values}) => (
                <Form className='formulario'>
                    {ubicacionEnviada && (opcionesServicios.length > 0) &&
                        <div className="select-box">
                          
                            <Select
                              placeholder={"Seleccione uno..."}
                              options={opcionesServicios}
                              onChange={(item) => {
                                setSelectedOptions(item.value);
                                setNombreServicio(item.value.nombre);
                                setAviso(<div dangerouslySetInnerHTML={{ __html: item.value.descripcionServicio }} />);
                                if(item.value.descripcionServicio) handleOpen();
                              }}
                              className="select"
                              isClearable={false}
                              isSearchable={true}
                              isDisabled={false}
                              isLoading={loading}
                              isRtl={false}
                              closeMenuOnSelect={true}
                              onFocus={desaparecerLupa}
                              onBlur={aparecerLupa}
                            />
                        
                            {necesitoLupita && <SearchIcon color="disabled" className='lupa-select' />}
                        
                    <ErrorMessage name="tipoTramite" component={() => (<div className='error'>{errors.tipoTramite}</div>)} />
                    </div>}
                    {opcionesServicios.length<=0 &&
                      <div>
                        <p>No hay trámites cargados.</p>
                      </div>
                    }

                <div className='buttonContainer'>
                  <button type='button' className='formulario-atrasButton' onClick={() => {setUbicacionEnviada(false); setServicios(null); setOpcionesServicios([]); setSelectedOptions(null)}}>Atras</button>
                  <Button disabled={loading} type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>
      
      <Accordion style={{"margin": "0px"}} expanded={tipoTraminteEnviado && !fechaEnviada} >
        <AccordionSummary
          style={{ pointerEvents: 'none'}}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <div>
            <Typography sx={textoPreguntas}>
              {fechaEnviada ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroModulo? 3 : 4}</Button>}
               
              Seleccione fecha del trámite 
            </Typography>
            {fechaEnviada && <Typography sx={respuestaElegida}> {datos.diaCompleto} {datos.hora} </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <div style={{display: "flex", justifyContent: "center"}}>
              <Calendar
                  locale={myCustomLocale}
                  value={selectedDay}
                  onChange={async(dia)=> {
                    setHoras([]);
                    setSelectedDay(dia);
                    setDatos({...datos, hora: ""});
                    const horaAux = await horasPorDia(setHoras, datos.idServicio, dia.day, dia.month, dia.year, setLoading);
                    noHayHoras(horaAux);
                    setMostrarHoras(true);
                  }}
                  minimumDate={utils().getToday()}
                  maximumDate={{...defaultDay, year: (defaultDay.year + 1), month: (defaultDay.month - 1)}}
                  disabledDays={disabledDays} // here we pass them
                  onDisabledDayError={handleDisabledSelect} // handle error
                  shouldHighlightWeekends
                  calendarClassName="responsive-calendar" 
              />
            </div>

            <div style={{marginTop: "2%", marginBottom: "2%"}}>
              <p> Seleccione una hora:</p>
              {mostrarHoras && horas.status != "error" && 
              <div style={{"flexWrap": "wrap", "justifyContent": "space-between"}}>
                {horas.filter(horario => horario.cupo > 0).map(horario => 
                  <>
                    <ThemeProvider theme={theme}>
                      <Button 
                        style={{"margin": "4px 5px", "borderRadius": "8px", "width": "55px" }}
                        key={horario.hora} 
                        value={horario.hora} 
                        color={(horario.hora === datos.hora) ? "secondary" : "desmarcado"}
                        variant="contained"
                        onClick={() => {
                          setDatos({...datos, hora: horario.hora});
                        }}> 
                        {horario.hora}</Button>
                    </ThemeProvider>
                  </>
                  )}
              </div>}
                  {mostrarNoHayHoras && <p>No hay horarios disponibles</p>}
            </div>
            <div className='buttonContainer'>
              <button type='button' className='formulario-atrasButton' onClick={() => {setTipoTraminteEnviado(false); setDatos({...datos, hora: null}); setMostrarHoras(false)}}>Atras</button>
              <Button 
                type='submit' 
                disabled={!datos.hora} 
                onClick={() => {
                  setDatos({...datos, diaCompleto: (selectedDay.year + "-"+ selectedDay.month + "-" + selectedDay.day), dia: fechaADia(selectedDay)});
                  setFechaEnviada(true);
                }}>Siguiente</Button>
            </div>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{"margin": "0px"}} expanded={fechaEnviada && !datosPersonalesEnviados} >
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography sx={{...textoPreguntas, "textAlign":"left" }}>
              {datosPersonalesEnviados ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroModulo? 4 : 5}</Button>}
            
            Datos personales 
          </Typography>
          {/* {fechaEnviada && <Typography sx={respuestaElegida}>  </Typography>}  */}
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={VALORES_INICIALES}
            validationSchema={elegirEsquemaVal()}
            
            onSubmit={async(valores) =>{
                setDatos({...datos,
                    nombreUser: valores.nombre,
                    apellidoUser: valores.apellido,
                    direccionUser: valores.domicilio,
                    emailUser: valores.correo,
                    telUser: valores.celular,
                });
                let payloadAux = {...datos,
                  nombreUser: valores.nombre,
                  apellidoUser: valores.apellido,
                  direccionUser: valores.domicilio,
                  emailUser: valores.correo,
                  telUser: valores.celular}
                if (!necesitaCheckDNI) {
                  setDatos({...datos, dniUser: valores.dni});
                  payloadAux.dniUser = valores.dni;
                }
                await setNuevoTurnoInfo(await insertarTurno(payloadAux, setLoading));
                setDatosPersonalesEnviados(true);
                setFormEnviado(true);
                // setAviso(
                //   <div>
                //     <h1> Tramite enviado con éxito</h1>
                //     <p>
                //       Nombre: {valores.nombre} <br/>
                //       Apellido: {valores.apellido}<br/>
                //       DNI: {payloadAux.dniUser}<br/><br/>

                //       Asistir a {nombreDelegacion} el {datos.diaCompleto} a las {datos.hora}
                //     </p>
                //   </div>
                // )
                // handleOpen()
            }}>
            {( { errors, }) => (
                <Form className='formulario'>
                  {!necesitaCheckDNI && <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="number" 
                      id="dni" 
                      name='dni'
                      label="Número de documento"
                      style={{"width": "50%"}}
                      />
                  </div>}
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="nombre" 
                      name='nombre' 
                      label="Nombre"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="apellido" 
                      name='apellido' 
                      label="Apellido"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="domicilio" 
                      name='domicilio' 
                      label="Domicilio"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="correo" 
                      name='correo' 
                      label="Email"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="celular" 
                      name='celular' 
                      label="Celular"
                      />
                  </div>
                  <div className='buttonContainer'>
                    <button type='button' className='formulario-atrasButton' onClick={() => (setFechaEnviada(false))}>Atras</button>
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
                
        </AccordionDetails>
      </Accordion>
      </div>
      {/* <button type='button' onClick={() => (console.log(datos))}>Ver Datos</button> */}
      {nuevoTurnoInfo && formEnviado && <NuevoTurno nombre={nuevoTurnoInfo.nombre} dni={nuevoTurnoInfo.dni} modulo={nuevoTurnoInfo.modulo.nombre} dependencia={nuevoTurnoInfo.dependencia.nombre} codigo={nuevoTurnoInfo.codigo} fecha={nuevoTurnoInfo.fecha} hora={nuevoTurnoInfo.hora} lugar={nuevoTurnoInfo.lugar} servicio={nuevoTurnoInfo.servicio} />}
    </div>
  );
}
